import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { VisibilityIconOff, VisibilityIconOn } from '@guryou/html-components';

const PasswordInput = ({ label, name, onChange, className = '', required, ...rest }) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = e => {
    if (onChange) {
      onChange(e.target.value, e);
    }
  };

  return (
    <div className={className}>
      {label && <label className="block mb-2 text-sm font-medium text-gray-900">{label}</label>}

      <div className="relative">
        <input
          {...rest}
          name={name}
          type={showPassword ? 'text' : 'password'}
          onChange={handleChange}
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring focus:ring-gray-300 block w-full p-2.5 pr-10"
        />

        <button
          type="button"
          onClick={() => setShowPassword(prev => !prev)}
          className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 hover:text-gray-700"
        >
          {showPassword ? <VisibilityIconOff /> : <VisibilityIconOn />}
        </button>
      </div>
    </div>
  );
};

PasswordInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func,
};

export default PasswordInput;
